module.exports = __webpack_public_path__ + "img/ljdk_zhCn.8e769f5f.png";